<template>
  <div class="height-100">

    <creating
      v-if="creating"
      height="100%" />

    <div v-if="!creating">
      <ul
        class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a
            class="nav-link disabled"
            :class="{ active: step === 1 }"
            href="javascript:void(0)">{{ $t('Download the app') }}</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link disabled"
            :class="{ active: step === 2 }"
            href="javascript:void(0)">{{ $t('Connect phone') }}</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link disabled"
            :class="{ active: step === 3 }"
            href="javascript:void(0)">{{ $t('Save the recovery key') }}</a>
        </li>
      </ul>
      <div :class="{ 'box-loading': loading }">
        <div v-if="step === 1">
          <h4>{{ $t('Install a verification app on your phone') }}</h4>
          <p>{{ $t('You\'ll need to use a verification app like Google Authenticator. Install from your app store.') }}</p>
          <button class="btn btn-primary" @click="step = 2">
            {{ $t('Already installed, go to step 2') }}
          </button>
        </div>
        <div v-if="step === 2">
          <h5>1. {{ $t('Scan this QR code with your verification app') }}</h5>
          <p>{{ $t('When your app scans the QR code, you\'ll receive a six-digit code.') }}</p>
          <img class="qrcode" v-if="imageUrl" :src="imageUrl">
          <hr>
          <h5>2. {{ $t('Enter the six-digit code here') }}</h5>
          <p>{{ $t('Enter the app code below. Once you\'re signed in, we\'ll remember your phone number, so you can use it every time you sign in.') }}</p>
          <form
            class="shurt-conatiner"
            v-on:submit.prevent="checkToken()">
            <div class="form-group">
              <label>{{ $t('Six-digit code') }}</label>
              <input
                type="text"
                class="form-control form-control-lg"
                style="max-width: 100px;"
                placeholder="000000"
                v-model="token">
              <ValidateMessage :error="validateErrors.token" />
            </div>
            <button
              type="submit"
              class="btn btn-primary">{{ $t('Connect phone') }}</button>
            <button
              type="button"
              class="btn btn-link"
              @click="step = 1">{{ $t('To go back') }}</button>
          </form>
        </div>
        <div v-if="step === 3">
          <h5>{{ $t('Save your recovery password') }}</h5>
          <ProfileTwofaSavepass
            :value="twofa_recovery_token"
            @checked="enable()" />
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import ProfileTwofaSavepass from './ProfileTwofaSavepass'

  export default {
    name: 'ProfileTwofaEnable',
    components: {
      ProfileTwofaSavepass
    },
    data () {
      return {
        step: 1,
        creating: true,
        loading: false,
        secret: null,
        token: null,
        imageUrl: null,
        recovery_token_check: false,
        validateErrors: false
      }
    },
    computed: {
      me () {
        return this.$store.getters.getMe
      }
    },
    created () {
      this.qrcode()
    },
    methods: {
      qrcode () {
        return this.axios.get('/auth/me/2fa/qrcode', {}).then(res => {
          if (res.data && res.data.imageUrl) {
            this.imageUrl = res.data.imageUrl
          }
          this.creating = false
        })
      },
      checkToken () {
        this.loading = true
        return this.axios.post('/auth/me/2fa/check-token', {
          token: this.token
        }).then(res => {
          if (res.data && res.data.twofa_recovery_token) {
            this.twofa_recovery_token = res.data.twofa_recovery_token
            this.step = 3
          }
        }).catch(err => {
          if (err.response.data.name === 'ValidationError') {
            this.validateErrors = err.response.data.errors
          }
        }).finally(() => {
          this.loading = false
        })
      },
      enable () {
        this.loading = true
        return this.axios.post('/auth/me/2fa/enable', {}).then(res => {
          if (res.data && res.data.twofa_enable === true) {
            this.$store.dispatch('setMe').then(() => {
              this.$router.push('/config/security')
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.qrcode {
  max-width: 212px;
  width: 100%;  
}
.recovery-token {
  letter-spacing: 0.25em;
  text-transform: uppercase;
  font-size: 1.6rem;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/ProfileTwofaEnable.vue